import React, { useEffect, useRef, useState } from 'react'
import { useLoader } from '@react-three/fiber'
import { MTLLoader, OBJLoader } from 'three-stdlib'

export default function OBJModel({
  objPath,
  mtlPath,
  scale = 1,
  position = [0, 0, 0],
  rotation = [0, 0, 0],
}) {
  const [object, setObject] = useState()

  useEffect(() => {
    const mtlLoader = new MTLLoader()
    mtlLoader.load(mtlPath, (materials) => {
      materials.preload()
      const objLoader = new OBJLoader()
      objLoader.setMaterials(materials)
      objLoader.load(objPath, (obj) => {
        obj.scale.set(scale, scale, scale)
        setObject(obj)
      })
    })
  }, [objPath, mtlPath, scale])

  return object ? <primitive object={object} position={position} rotation={rotation} /> : null
}
